export function getActiveRecurrence(issuer) {
  const list = Array.isArray(issuer?.issuer_x_recurrence)
    ? issuer.issuer_x_recurrence
    : issuer?.issuer_x_recurrence
    ? [issuer.issuer_x_recurrence]
    : [];
  return (
    list.find((r) => r.active === true) ?? list[list.length - 1] ?? null
  );
}
